<template>
    <section class="item-footer">
        <div class="price">
            <p v-if="this.data.priceFormatted">{{this.$parent.priceFrom}} {{ this.data.priceFormatted }}</p>
            <p v-else></p>
        </div>

        <div class="action">
            <slot>Drück mich!</slot>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'ItemFooter',
        props: {
            data: null,
        },
    }
</script>

<style lang="scss" scoped>
    .item-footer {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 30px;
        min-height: 140px;

        .price {
            font-size: 22px;
        }

        .action {
            width: 100%;
            padding: 0 40px;

            @media ( max-width: 1024px ) {
                padding: 0;
            }

            button {
                width: 100%;
                padding: 15px;
                background: #E60014;
                color: white;
                font-size: 12px;
            }
        }
    }
</style>